export default __webpack_public_path__ + "static/media/MOTIVO_05.05024cee.jpg";